var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar__view",class:{
         'calendar__view--anonymous': _vm.anonymous,
         'calendar__view--contact-request-appointment-planning-mode': _vm.contactRequestAppointmentPlanningModeActive,
         'calendar__view--all-day-slot': _vm.showCalendarNotes
     }},[_c('div',{ref:"fullcalendar"})])}
var staticRenderFns = []

export { render, staticRenderFns }